import { LoadingStatusType } from "@/enums/enums";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import API from "@/service/index";
import { ToProductList } from "@/service/product/productFacade";

@Module({ namespaced: true })
export default class Product extends VuexModule {
  public productTemplateList: any = null;
  public productTemplateListLoadingStatus = LoadingStatusType.None;

  get getAllProductTemplateList(): any {
    return this.productTemplateList;
  }

  get getProductTemplateListLoadingStatus(): LoadingStatusType {
    return this.productTemplateListLoadingStatus;
  }

  @Mutation
  public MutationSetIsLoadingStatus(status: LoadingStatusType) {
    this.productTemplateListLoadingStatus = status;
  }

  @Mutation
  public MutationProductTemplateList(productTemplateList: any) {
    this.productTemplateList = productTemplateList;
  }

  @Action
  public DoGetAllProductTemplate(isUseMainDatabase = false) {
    if (this.productTemplateListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetIsLoadingStatus", LoadingStatusType.Loading);
      API.ProductService.DoGetAllProductTemplate(isUseMainDatabase)
        .then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            const productList = ToProductList(res.data.productList);
            this.context.commit("MutationProductTemplateList", productList);
          }
          this.context.commit("MutationSetIsLoadingStatus", LoadingStatusType.Success);
        })
        .catch((error) => error);
    }
  }
}
